import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IModule } from 'src/app/interfaces/IModule';
import { selectMenu } from 'src/app/selectors/menu.selector';
import { paths } from 'src/component-paths/component-paths';
import { CanComponentLeave } from 'src/app/guards/can-leave.guard';
import { UnsavedChangesGuard } from 'src/app/guards/unsaved-changes.guard';
import { CareTeamManagementComponent } from './care-team-management/care-team-management.component';

@Component({
  selector: 'app-tenant-management',
  templateUrl: './tenant-management.component.html',
  styleUrls: ['./tenant-management.component.css'],
  standalone: false,
})
export class TenantManagementComponent implements CanComponentLeave {
  @ViewChild(CareTeamManagementComponent)
  careTeamManagement?: CareTeamManagementComponent;

  public menuData?: IModule;
  public isCollapsed: boolean = false;

  public selectedOption?: number;

  componentPaths = paths.tenantManagement;

  constructor(
    private readonly store: Store,
    private readonly cdref: ChangeDetectorRef,
    private readonly unsavedChangesGuard: UnsavedChangesGuard
  ) {}

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  clickItem(m: IModule) {
    if (m.id === this.selectedOption) {
      return;
    }

    if (this.careTeamManagement?.hasUnsavedChanges()) {
      this.unsavedChangesGuard.showDiscardChangesDialog().subscribe((confirmed) => {
        if (confirmed) {
          this.selectedOption = m.id;
        }
      });
      return;
    }

    this.selectedOption = m.id;
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.careTeamManagement?.hasUnsavedChanges()) {
      return this.unsavedChangesGuard.showDiscardChangesDialog();
    }

    return true;
  }

  activeSubmenu(): string {
    return (
      this.menuData?.childModules?.find((d) => d.id === this.selectedOption)
        ?.path || ''
    );
  }

  ngOnInit() {
    if (window.innerWidth <= 1919) {
      this.isCollapsed = true;
      this.cdref.detectChanges();
    }

    this.store.select(selectMenu).subscribe((data) => {
      this.menuData = data.find((d) => d.path == 'tenantManagement');

      this.selectedOption = this.menuData?.childModules?.at(0)?.id;
    });
  }
}
